import type { MessageDescriptor } from 'react-intl-next';

import { aiExperienceApplicationMessages } from '@atlaskit/editor-common/ai-messages';
import { fg } from '@atlaskit/platform-feature-flags';

export const mapLoadingStatusToMessageTemplate = (
	messageTemplate: string | undefined,
): MessageDescriptor | undefined => {
	switch (messageTemplate) {
		case 'ANALYSING_QUERY':
			return aiExperienceApplicationMessages.messageTemplateAnalysingQuery;
		case 'CONTENT_SEARCH':
			return aiExperienceApplicationMessages.messageTemplateContentSearch;
		case 'PAGE_HYDRATION':
			return aiExperienceApplicationMessages.messageTemplatePageHydration;
		case 'NEXT_BEST_TASK':
			return aiExperienceApplicationMessages.messageTemplateNextBestTask;
		case 'WRITING':
			return aiExperienceApplicationMessages.loadingTitle;
		default:
			return fg('editor_ai_loading_text_fallback_to_generating')
				? aiExperienceApplicationMessages.generatingAiResponse
				: undefined;
	}
};
